import { render, staticRenderFns } from "./tooltip-quarternary.vue?vue&type=template&id=98a96e26&scoped=true"
import script from "./tooltip-quarternary.vue?vue&type=script&lang=js"
export * from "./tooltip-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a96e26",
  null
  
)

export default component.exports